import React, { useState, useEffect } from 'react';
import styles from './ScrollTopArrow.module.scss';

function ScrollTopArrow() {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && global.window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && global.window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  useEffect(() => {
    global.window.addEventListener('scroll', checkScrollTop);
    return function cleanup() {
      global.window.removeEventListener('scroll', checkScrollTop);
    };
  });

  const scrollTop = () => global.window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Back to top"
      className={styles.scrollTop}
      onClick={scrollTop}
      onKeyDown={scrollTop}
      style={{ height: 40, opacity: showScroll ? '1' : '0' }}
    />
  );
}

export default ScrollTopArrow;
